import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseChartDirective } from 'ng2-charts';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { FilterButtonComponent } from 'src/app/components/filter-button/filter-button.component';
import { RecipientInputModule } from 'src/app/components/recipient-input/recipient-input.module';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AnalyticsResponseTimesRoutingModule } from './analytics-response-times-routing.module';
import { AnalyticsResponseTimesComponent } from './analytics-response-times.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BaseChartDirective,
    SharedPipesModule,
    AnalyticsResponseTimesRoutingModule,
    NgxTippyModule,
    NgxDatatableModule,
    RecipientInputModule,
    FilterButtonComponent,
    SharedDirectivesModule,
  ],
  declarations: [AnalyticsResponseTimesComponent],
})
export class AnalyticsResponseTimesModule {}
